// YYYY-MM-DD
const yearStartReg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
// DD-MM-YYYY
const dateStartReg = /^(0[1-9]|[1-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-[1-9]\d{3}$/;

export function hhmmss(timeSeconds) {
    timeSeconds = parseInt(timeSeconds, 10);
    const seconds = timeSeconds % 60;
    const minutes = (timeSeconds - seconds) / 60;
    const min = minutes % 60;
    const hours = (minutes - min) / 60;
    return `${prefixZero(hours)}:${prefixZero(min)}:${prefixZero(seconds)}`;
}

export function datetime(date, time) {
    const datetime = new Date(1970, 1, 1);
    if (date && date.indexOf('-') > -1) {
        date = convertYYYYMMDD(date);
    }
    if (date && date.length === 8) {
        datetime.setFullYear(parseInt(date.substring(0, 4), 10));
        datetime.setMonth(parseInt(date.substring(4, 6), 10) - 1);
        datetime.setDate(parseInt(date.substring(6, 8), 10));
    }
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    if (time) {
        const timeArray = time.split(':');
        hours = parseInt(timeArray[0], 10);
        minutes = parseInt(timeArray[1], 10);
        seconds = parseInt(timeArray[2] || 0, 10);
    }
    datetime.setHours(hours);
    datetime.setMinutes(minutes);
    datetime.setSeconds(seconds);
    datetime.setMilliseconds(0);
    return datetime;
}

export function getDate(datetime) {
    return `${datetime.getFullYear()}${prefixZero(
        datetime.getMonth() + 1
    )}${prefixZero(datetime.getDate())}`;
}

export function getTime(datetime) {
    return `${prefixZero(datetime.getHours())}:${prefixZero(
        datetime.getMinutes()
    )}:${prefixZero(datetime.getSeconds())}`;
}

export function minusMinutes(datetime, value) {
    return new Date(datetime.getTime() - value * 60000);
}

export function getStrikeDateString(date) {
    date = getDate(date);
    return `${date.substring(6, 8)}-${date.substring(4, 6)}-${date.substring(
        0,
        4
    )}`;
}

export function convertYYYYMMDD(date) {
    if (typeof date !== 'string') {
        return null;
    }
    if (yearStartReg.test(date)) {
        return date.replace(/(\d+)(-|\.)(\d+)(-|\.)(\d+)/, '$1$3$5');
    } else if (dateStartReg.test(date)) {
        return date.replace(/(\d+)(-|\.)(\d+)(-|\.)(\d+)/, '$5$3$1');
    }
    return date;
}

export function prefixZero(num) {
    return num < 10 ? `0${num}` : num;
}
